import { Link } from '@routable/gross-ds';
import PropTypes from 'prop-types';
import React from 'react';

const LinkLearnMore = ({ href, transformText }) => (
  <Link href={href} openInNewTab>
    {transformText('Learn more')}
  </Link>
);

LinkLearnMore.propTypes = {
  href: PropTypes.string.isRequired,
  transformText: PropTypes.func,
};

LinkLearnMore.defaultProps = {
  transformText: (str) => str,
};

export default LinkLearnMore;
